import { Link as LinkIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

interface CopyLinkButtonProps {
  /** The page's app path from `useOrgPaths()`, e.g. `/orgs/{orgId}/trials/{trialId}`. */
  path: string;
}

/**
 * Copies a shareable link to a page. The path comes from the org path builders,
 * never from `window.location.pathname`: during a route transition the address
 * bar already shows the next page.
 */
export default function CopyLinkButton({ path }: CopyLinkButtonProps) {
  const { toast } = useToast();

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(`${window.location.origin}${path}`);
      toast({ title: "Link copied" });
    } catch {
      toast({ title: "Couldn't copy the link", variant: "destructive" });
    }
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="h-8 w-8"
      aria-label="Copy link"
      title="Copy link"
      onClick={() => void copyLink()}>
      <LinkIcon
        className="h-4 w-4"
        aria-hidden="true"
      />
    </Button>
  );
}
